import React from "react";
import cn from "classnames";

import styles from "./styles.module.scss";

interface InputProps {
  wrapperClass?: string;
  postfix?: string;
  isError?: boolean;
  [key: string]: any;
}

const Input = ({ wrapperClass, postfix, isError, ...props }: InputProps) => (
    <div
        className={cn(styles.inputWrapper, wrapperClass, {
            [styles["inputWrapper--error"]]: isError,
            [styles["inputWrapper--disabled"]]: props.disabled,
        })}
    >
        <input className={styles.input} {...props} />
        {postfix && <div className={styles.postfix}>{postfix}</div>}
    </div>
);

export default Input;
